import React from 'react';
import { default as Form } from '../../components/connectedForm';
import {
  GenericArrayCard,
  GenericArrayCardSubtitle,
  GenericArrayCardTitle,
} from '../../components/connectedForm/GenericArray';
import HeaderStatus from '../../components/connectedForm/HeaderStatus';
import { ICustomerContact, Maybe } from '../../graphql/schema/p4types';

export default function ContactCard({ value: rowData }: Readonly<{ value: ICustomerContact }>) {
  let name: Maybe<string>;
  let email: Maybe<string>;
  if (!rowData) {
    name = 'New Contact';
    email = null;
  } else {
    name = rowData.name?.fullName;
    email = rowData.email;
  }

  return (
    <GenericArrayCard>
      <GenericArrayCardTitle>{name}</GenericArrayCardTitle>
      <Form.Row>
        <Form.Fieldset cols={1 / 2}>
          <GenericArrayCardSubtitle>{email}</GenericArrayCardSubtitle>
        </Form.Fieldset>
        <div style={{ display: 'flex', flexWrap: 'wrap' }}>
          <Form.Fieldset cols={1}>
            {rowData && rowData.primaryContact ? <HeaderStatus statusStyle={'info'} title={'Primary'} /> : null}
            {rowData && rowData.customerGlobalContact ? <HeaderStatus title={'Global'} /> : null}
          </Form.Fieldset>
        </div>
      </Form.Row>
    </GenericArrayCard>
  );
}
